import { render, staticRenderFns } from "./EmployeeDocuments.vue?vue&type=template&id=732f9164"
import script from "./EmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./EmployeeDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports